module.exports = "<app-toolbar *ngIf=\"showTopBar\"></app-toolbar>\n\n<div class=\"app-body\">\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main